/* --- inline script #0 --- */

(function(){
  const el = document.getElementById('timestampEl');
  if (!el) return;
  const colon = el.querySelector('.blink');
  function tick(){
    const d = new Date();
    let h = d.getHours();
    const m = String(d.getMinutes()).padStart(2,'0');
    const s = String(d.getSeconds()).padStart(2,'0');
    const ap = h >= 12 ? 'PM' : 'AM';
    h = h % 12; if (h === 0) h = 12;
    el.firstChild.nodeValue = h + ':' + m;
    colon.nextSibling.nodeValue = s + ' ' + ap;
  }
  tick();
  setInterval(tick, 1000);
})();
